import * as React from "react";
import {connect} from "react-redux";

import Icon from "../static/Icons";
import Modal from "../static/Modal";
import {Button} from "../static/Elements";
import {FormInput, TextField} from '../static/Inputs';

import createLogger from '../../utils/createLogger';
import { updateAgency, removeAgency } from '../../data/agencies/agenciesActions';
import {createDidError, createIsLoading} from "../../data/requests/requestsSelectors";
import ReactLoading from "react-loading";

const DEBUG = true;
const debug = createLogger(DEBUG, `AgencyEntry.js`);

const mapStateToProps = (state) => {
  const didError = createDidError(AgencyEntry.dependencies);
  const isLoading = createIsLoading(AgencyEntry.dependencies);

  return {
    isAuthenticated: !!state.auth.session,
    agencies: state.agencies.agencies,
    didError: didError(state),
    isLoading: isLoading(state),
  }
};

const mapDispatchToProps = {
  updateAgency,
  removeAgency,
};


class AgencyEntry extends React.Component {

  static dependencies = [
    `PUT_AGENCY`,
    `DELETE_AGENCY`
  ];

  /*-------- lifecycle methods --------*/

  constructor(props) {
    super(props);
    this.state = {
      deleteModalIsOpen: false,
      editModalIsOpen: false,
      domain: props.agency.url,
    }
  }

  /*-------- event handlers --------*/

  openDeleteModal = () => this.setState({deleteModalIsOpen: true});
  closeDeleteModal = () => this.setState({deleteModalIsOpen: false});

  openEditModal = () => this.setState({editModalIsOpen: true});
  closeEditModal = () => this.setState({editModalIsOpen: false});

  onInputChange = (field) => (input) => {
    console.log (input);
    this.setState ({...this.state, [field]: input});
  };

  confirmDelete = () => {
    const _id = this.props.agency._id;
    debug.log('deleting agency with id ', _id);
    this.props.removeAgency(_id);
    this.closeDeleteModal();
  };

  confirmUpdate = () => {
    this.props.updateAgency(this.props.agency._id, {domain: this.state.domain});
    this.closeEditModal();
  };

  /*-------- render methods --------*/

  render () {

    const {
      agency,
      isLoading,
    } = this.props;

    const {
      deleteModalIsOpen,
      editModalIsOpen,
      domain,
    } = this.state;

    const {
      openDeleteModal,
      closeDeleteModal,
      openEditModal,
      closeEditModal,
      onInputChange,
      confirmDelete,
      confirmUpdate,
    } = this;

    const domainFieldConfig = {
      type: 'text',
      value: domain,
      label: 'Agency domain (e.g. "linkedin.com")',
      onChange: onInputChange('domain'),
    };


    return (
      <div className='domain-entry' key={agency._id}>

        <Modal title='Remove agency domain'
               isOpen={deleteModalIsOpen}
               close={closeDeleteModal}
               closeButton>
          {
            isLoading ? (
              <ReactLoading type={'bubbles'} color={'#6b6c6f'}/>
            ) : (
              <div className='delete-agency-container'>
                <div className='display-agency'>
                  <h5>{agency.url}</h5>
                </div>
                <div className='modal-footer-actions'>
                  <Button danger onClick={confirmDelete}>
                    <Icon.Remove/> Delete
                  </Button>
                </div>
              </div>
            )
          }

        </Modal>

        <Modal title='Edit agency domain'
               isOpen={editModalIsOpen}
               close={closeEditModal}
               closeButton>
          <div className='edit-agency-container'>
            <FormInput className='agency-fields'>
              <TextField {...domainFieldConfig}/>
            </FormInput>
            <div className='modal-footer-actions'>
              <Button primary onClick={confirmUpdate}>
                Update
              </Button>
            </div>
          </div>
        </Modal>

        <h5>{agency.url}</h5>
        <div className="agency-actions">
          <Button lowkey onClick={openEditModal}>
            <Icon.Edit/>
          </Button>
          <Button lowkey danger onClick={openDeleteModal}>
            <Icon.Close/>
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgencyEntry);


// WEBPACK FOOTER //
// ./src/components/Agencies/AgencyEntry.js